import script from "./Reporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Reporting.vue?vue&type=script&lang=ts&setup=true"

import "./Reporting.vue?vue&type=style&index=0&id=c3e252fe&lang=css"

const __exports__ = script;

export default __exports__